import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'suka-table-skeleton, table[suka-table-skeleton]',
  exportAs: 'sukaTableSkeleton',
  template: `
    <tr class="suka-header-row">
      <th *ngFor="let column of columns" class="suka-header-cell"><div class="skeleton__text"></div></th>
    </tr>
    <tr class="suka-row" *ngFor="let row of rows">
      <td *ngFor="let column of columns" class="suka-cell"><div class="skeleton__text"></div></td>
    </tr>
  `,
})
export class SukaTableSkeleton {
  @HostBinding('class.suka-table') baseClass = true;
  @HostBinding('class.suka-table--full-width') @Input() fullWidth = false;

  @Input() skeleton = false;

  @Input() columns = [];

  @Input() rowNumber = 5;

  rows = Array(this.rowNumber).fill(0).map((x, i) => i);
}
